import React, { Component } from "react";
import { PanelComponent } from "./PanelComponent";
import FormContainer from "../Form/FormContainer";
import { Button } from "antd";
import { v1 as uuidv1 } from "uuid";

class PanelContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forms: []
    };
  }
  addForm = () => {
    const { filteredmappings } = this.state;
    filteredmappings.push({
      type: this.props.type,
      source: "",
      destination: "",
      new: true,
      id: uuidv1
    });
    this.setState({ filteredmappings });
  };

  componentDidMount() {
    const { custommappings, type } = this.props;
    if (custommappings) {
      let filteredMapping = custommappings.filter(item => item.type === type);
      this.setState({ filteredmappings: filteredMapping }, () =>
        this.addForm()
      );
    }
  }
  render() {
    const { forms, filteredmappings } = this.state;
    const { type, loadCustomMappings } = this.props;
    if (filteredmappings)
      return (
        <PanelComponent title={type}>
          {filteredmappings.map((item, index) => (
            <FormContainer
              addForm={this.addForm}
              sourceValue={item.source}
              destinationValue={item.destination}
              type={type}
              key={item.id}
              newForm={item.new ? true : false}
              id={item.id}
              loadCustomMappings={loadCustomMappings}
            />
          ))}
          <div className="text-right">
            <Button
              size="small"
              onClick={this.addForm}
              type="primary"
              style={{ display: "none", marginTop: "10px", marginRight: "3px" }}
            >
              Add
            </Button>
          </div>
        </PanelComponent>
      );
    return null;
  }
}

export default PanelContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panel/PanelContainer.js